import { HttpContextToken } from '@angular/common/http';

/**
 * HttpContext option to disable showing the API error banner for the middleware error code
 */
export const DISABLE_ERROR_CODE_ID_BANNER = new HttpContextToken<(string | number)[]>(() => []);

/**
 * HttpContext option to disable showing the API error banner for the backend error code
 */
export const DISABLE_BACKEND_ERROR_CODE_ID_BANNER = new HttpContextToken<(string | number)[]>(() => []);
